import { IonContent, IonLabel, IonList, IonPage } from '@ionic/react';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';
import { PlanEntitlementKey } from '../../api/graphql/generated';
import { useHasFeature } from '../../api/hooks/feature.hooks';
import { PageHeader } from '../../components/header/page.header';
import { IonItem } from '../../components/ionic/IonItem';
import { PaywallIonItem } from '../../components/paywall/paywall-ion-item';
import { useBeaconRouter } from '../../route/route.hooks';

const Adminland = (): ReactElement => {
  const { builder } = useBeaconRouter();
  const { i18n } = useTranslation();
  const hasEnhancedUserRoles = useHasFeature<boolean>(
    'beacon-enhanced-user-roles'
  );

  return (
    <IonPage>
      <PageHeader title={i18n.t('common:admin')} />
      <IonContent>
        <IonList lines="full">
          <IonItem routerLink={builder.getAdminTenantRoute()}>
            <IonLabel>{i18n.t('common:workspace')}</IonLabel>
          </IonItem>
          <IonItem routerLink={builder.getAdminUsersRoute()}>
            <IonLabel>{i18n.t('common:workspace_manage_users')}</IonLabel>
          </IonItem>
          {hasEnhancedUserRoles && (
            <PaywallIonItem
              planEntitlementKey={PlanEntitlementKey.ENHANCED_USER_ROLES}
              ionItemProps={{
                routerLink: builder.getAdminRolesRoute(),
              }}
            >
              <IonLabel>{i18n.t('common:workspace_manage_roles')}</IonLabel>
            </PaywallIonItem>
          )}
          <IonItem routerLink={builder.getAdminTeamsRoute()}>
            <IonLabel>{i18n.t('common:workspace_manage_teams')}</IonLabel>
          </IonItem>
          <IonItem routerLink={builder.getAdminMachinesRoute()}>
            <IonLabel>{i18n.t('common:workspace_manage_machines')}</IonLabel>
          </IonItem>
          <PaywallIonItem
            planEntitlementKey={
              PlanEntitlementKey.EVENT_CHANNEL_WEBHOOK_SERVICE
            }
            ionItemProps={{
              routerLink: builder.getAdminEventIntegrationsRoute(),
            }}
          >
            <IonLabel>
              {i18n.t('common:workspace_manage_integrations')}
            </IonLabel>
          </PaywallIonItem>
          <IonItem routerLink={builder.getAdminExportRoute()}>
            <IonLabel>{i18n.t('common:workspace_export_data')}</IonLabel>
          </IonItem>
        </IonList>
      </IonContent>
    </IonPage>
  );
};

export { Adminland };
